module.exports = __webpack_public_path__ + "img/img8.67a01153.png";